// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1MmR8","description":"PatientConsentPreview_description__1hmgy"};